import { AnyAction } from 'redux';
import { Classification } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';

import {
    CLASSIFICATIONS_RECEIVED,
    CLASSIFICATIONS_REQUEST,
    CLASSIFICATION_CREATE,
    CLASSIFICATION_CREATED,
    CLASSIFICATION_DELETE,
    CLASSIFICATION_DELETE_ERROR,
    CLASSIFICATION_DELETE_ERROR_CLEAR,
    CLASSIFICATION_FAILED,
    CLASSIFICATION_UPDATE,
} from './classifications-actions';

export interface ClassificationsReducerState {
    classifications: PaginatedResponse<Classification>;
    requesting: boolean;
    deleteErrorClassificationId?: number;
}

export const initialClassificationsReducerState: ClassificationsReducerState = {
    classifications: { items: [], limit: 0, page: 0, total: 0 },
    requesting: false,
};

export const classificationsReducer = (
    state: ClassificationsReducerState = initialClassificationsReducerState,
    action: AnyAction
): ClassificationsReducerState => {
    const { type } = action;

    switch (type) {
        case CLASSIFICATION_CREATE:
        case CLASSIFICATIONS_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case CLASSIFICATIONS_RECEIVED: {
            return {
                ...state,
                classifications: action['classifications'],
                requesting: false,
            };
        }

        case CLASSIFICATION_DELETE: {
            return {
                ...state,
                classifications: {
                    ...state.classifications,
                    items: state.classifications.items.filter(
                        (classification: Classification) => classification.id !== action['classificationId']
                    ),
                    total: state.classifications.total - 1,
                },
            };
        }

        case CLASSIFICATION_UPDATE: {
            return {
                ...state,
                classifications: {
                    ...state.classifications,
                    items: state.classifications.items.map((classification: Classification) => {
                        if (classification.id === action['classification'].id) {
                            return action['classification'];
                        }
                        return classification;
                    }),
                },
            };
        }

        case CLASSIFICATION_CREATED: {
            return {
                ...state,
                classifications: {
                    ...state.classifications,
                    items: [action['classification'], ...state.classifications.items],
                },
                requesting: false,
            };
        }

        case CLASSIFICATION_DELETE_ERROR: {
            return {
                ...state,
                deleteErrorClassificationId: action['classificationId'],
            };
        }

        case CLASSIFICATION_DELETE_ERROR_CLEAR: {
            return {
                ...state,
                deleteErrorClassificationId: undefined,
            };
        }

        case CLASSIFICATION_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
